import React from 'react'
import SimpleSlider from '../content-modules/SimpleSlider'
import CardE from './CardE'

/**
 * Renders a slider of images.
 *
 * @param {array} images An array of image objects with the following properties: src, caption, alt
 */
export default function ImageSlider({ images, ...props }) {
    return (
        <SimpleSlider
            className="center full-width"
            slidesToShow="1"
            centerMode
            infinite
            variableWidth
            {...props}>
            {images.map(image => (
                <CardE
                    key={image.src}
                    fooImage={image.src}
                    caption={image.caption}
                    alt={image.alt}
                />
            ))}
        </SimpleSlider>
    )
}
